export default __webpack_public_path__ + "static/Rio-de-Janeiro-c0a1916a2c544b58cc6f767b4888a53a.jpg";